const ORDER_UPDATE_RESULT_FIELDS = `
  orderId
  orderNumber
  orderStatus
  reservationStatus
  scheduledPaymentDate
  reservationNumber
  updatedAt
`;

const CREATE_ORDER_JOB_RESULT_FIELDS = `
  jobId
  status
  errorCode
  lastError
  userMessage
  createdOrders {
    orderId
    orderNumber
    displayCode
    serviceIds
    ticketIds
    idItinerary
    providerId
    currency
    orderStatus
    scheduledPaymentDate
    freezeDeadlineAt
    reservationNumber
    orderObservation
    pdfStatus
    baseAmount
    commissionPercent
    commissionAmount
    total
  }
  rejectedServices {
    serviceId
    ticketId
    reason
    message
    userMessage
  }
  warnings {
    serviceId
    groupKey
    reason
    message
    userMessage
  }
`;

export const CONFIRM_PRELIMINARY_ORDER_MUTATION = `
mutation ConfirmPreliminaryOrder($orderId: ID!) {
  confirmPreliminaryOrder(orderId: $orderId) {
    orderId
    orderNumber
    orderStatus
    displayCode
    pdfStatus
  }
}
`;

export const RECALCULATE_PRELIMINARY_ORDER_MUTATION = `
mutation RecalculatePreliminaryOrder($orderId: ID!) {
  recalculatePreliminaryOrder(orderId: $orderId) {
    updatedCount
    orderIds
  }
}
`;

export const UPDATE_ORDER_FREEZE_DEADLINE_MUTATION = `
mutation UpdateOrderFreezeDeadline($orderId: ID!, $freezeDeadlineAt: String!) {
  updateOrderFreezeDeadline(orderId: $orderId, freezeDeadlineAt: $freezeDeadlineAt) {
    orderId
    orderNumber
    orderStatus
    displayCode
    pdfStatus
  }
}
`;

export const CREATE_ORDER_MUTATION = `
  mutation CreateOrder($input: CreateOrderInput!) {
    createOrder(input: $input) {
      ${CREATE_ORDER_JOB_RESULT_FIELDS}
    }
  }
`;

export const GET_ORDER_RECALC_HISTORY_QUERY = `
  query GetOrderRecalcHistory($orderId: ID!) {
    getOrderRecalcHistory(orderId: $orderId) {
      historyId
      orderId
      trigger
      source
      previousTotal
      newTotal
      changedAt
      lineDeltas {
        orderLineId
        serviceId
        previousAmount
        newAmount
        previousPax
        newPax
      }
    }
  }
`;

export const GET_CREATE_ORDER_JOB_QUERY = `
  query GetCreateOrderJob($jobId: ID!) {
    getCreateOrderJob(jobId: $jobId) {
      ${CREATE_ORDER_JOB_RESULT_FIELDS}
    }
  }
`;

export const UPDATE_ORDER_SCHEDULED_PAYMENT_DATE_MUTATION = `
  mutation UpdateOrderScheduledPaymentDate($input: UpdateOrderScheduledPaymentDateInput!) {
    updateOrderScheduledPaymentDate(input: $input) {
      ${ORDER_UPDATE_RESULT_FIELDS}
    }
  }
`;

export const UPDATE_ORDER_RESERVATION_NUMBER_MUTATION = `
  mutation UpdateOrderReservationNumber($input: UpdateOrderReservationNumberInput!) {
    updateOrderReservationNumber(input: $input) {
      ${ORDER_UPDATE_RESULT_FIELDS}
    }
  }
`;

export const UPDATE_ORDER_RESERVATION_STATUS_MUTATION = `
  mutation UpdateOrderReservationStatus($input: UpdateOrderReservationStatusInput!) {
    updateOrderReservationStatus(input: $input) {
      ${ORDER_UPDATE_RESULT_FIELDS}
    }
  }
`;

export const DELETE_ORDER_MUTATION = `
  mutation DeleteOrder($input: DeleteOrderInput!) {
    deleteOrder(input: $input) {
      ${ORDER_UPDATE_RESULT_FIELDS}
      releasedCosts {
        serviceId
        ticketId
        editOperation
        newTotalCostoDolares
        newTotalCostoSoles
        totalCostoDolares
        totalCostoSoles
      }
    }
  }
`;

export const CREATE_ORDER_PDF_DOWNLOAD_URL_MUTATION = `
  mutation CreateOrderPdfDownloadUrl($orderId: ID!, $disposition: String) {
    createOrderPdfDownloadUrl(orderId: $orderId, disposition: $disposition) {
      pdfStatus
      errorCode
      lastPdfError
      userMessage
      url
      expiresAt
    }
  }
`;

export const RETRY_GENERATE_ORDER_PDF_MUTATION = `
  mutation RetryGenerateOrderPdf($orderId: ID!) {
    retryGenerateOrderPdf(orderId: $orderId) {
      orderId
      pdfStatus
      pdfGeneratedAt
    }
  }
`;

export const GET_ORDERS_AVAILABLE_PAGE_QUERY = `
  query GetOrdersAvailablePage($input: GetOrdersAvailableInput) {
    getOrdersAvailablePage(input: $input) {
      items {
        orderId
        orderNumber
        orderStatus
        reservationNumber
        reservationStatus
        paymentCondition
        paidAt
        scheduledPaymentDate
        currency
        total
        commissionPercent
        commissionAmount
        providerSnapshot {
          name
        }
        fileSnapshot {
          fileNumber
          fileExtend
        }
        lines {
          serviceId
          serviceSnapshot {
            serviceType
          }
        }
      }
      lastKey
    }
  }
`;
